export enum TPIProviderTypeEnum {
  LOBBY = 1,
  GAMES = 2,
  OTHER = 3,
}
